<div class="wrap-x pos-relative overflow-hidden animation-long p-t p-b"
     [class.animation-fade-in]="!client.isCms && component.animation"
     [gsap]
     [gsapOff]="client.isCms || !component.animation"
     [scrollTrigger]="{
       start: '50% bottom', end: '100% top', toggleClass: 'is-animate', once: true
    }">

    @if (!client.isS || (client.isS && component.show_image_mobile === 'show_1_img')) {
    <div class="w-6 w-12-s">
        <div class="ratio-8-9 ratio-1-1-s overflow-hidden">
            @if (component.video_id_1 && !component.image_1) {
            <shell />
            }
            @if (component.image_1) {
            <div class="rf z-1"
                 [gsap]="{ y: '20%' }"
                 [gsapOff]="client.isCms || !component.animation"
                 [scrollTrigger]="{ start: '0% top', end: '100% top', id: 'parallax' }">
                <href [link]="component.text_placement === 'centered_text_box' ? component.link_3 : component.link_1">
                    <img class="z-1"
                         [dfImage]="component.image_1"
                         [priority]="component.cwvLoading === 'eager' || component.cwvPriority"
                         [ratio]="client.isS ? '1' : '8/9'"
                         fill>
                </href>
            </div>
            }
            @if (component.video_id_1) {
            <href [link]="component.text_placement==='centered_text_box' ? component.link_3 : component.link_1">
                <local-vimeo-player class="rf z-2 bg-col-w"
                                    [video-id]="component.video_id_1"
                                    [autoplay-in-viewport]="true" />
            </href>
            }
            @if (component.text_placement === 'on_image_text_box' && !client.isS) {
            <href [link]="component.link_1">
                <div class="fill z-3 flex flex-bottom flex-justify-center">
                    <div class="w-8 flex flex-column flex-justify-between"
                         [ngClass]="[component.align_1 || 'center']"
                         [style.color]="component.text_color_1"
                         [style.height.%]="56"
                         [gsap]="{ opacity: 0 }"
                         [gsapOff]="client.isCms || !component.animation"
                         [scrollTrigger]="{ id: 'opacity', start: '55% center', end: '80% center' }">
                        <div>
                            <p class="m-b-2"
                               [ngClass]="component.heading_1 ? 'o1' : ''"
                               *iCms="'heading_1' of component"></p>

                            <h1 [ngClass]="[component.title_style_1 || 'h1', component.title_1 || 'm-b-1']"
                                *iCms="'title_1' of component"></h1>

                            <a [ngClass]="component.cta_style_1 || 'p2'"
                               [routerLink]="component.link_1">
                                <span class="button__body"
                                      *iCms="'cta_text_1' of component"></span>
                            </a>
                        </div>

                        <div [ngClass]="component.caption_1 ? 'c1 p-b-3' : ''"
                             *iCms="'caption_1' of component"></div>
                    </div>
                </div>
            </href>
            }
        </div>
    </div>
    }

    @if (!client.isS || (client.isS && component.show_image_mobile === 'show_2_img')) {
    <div class="w-6 w-12-s">
        <div class="ratio-8-9 ratio-1-1-s overflow-hidden">
            @if (component.image_2) {
            <div class="rf z-1"
                 [gsap]="{ y: '20%' }"
                 [gsapOff]="client.isCms || !component.animation"
                 [scrollTrigger]="{ start: '0% top', end: '100% top', id: 'parallax' }">
                <href [link]="component.text_placement==='centered_text_box' ? component.link_3 : component.link_2">
                    <img class="z-1"
                         [dfImage]="component.image_2"
                         [priority]="component.cwvLoading === 'eager' || component.cwvPriority"
                         [ratio]="client.isS ? '1' : '8/9'"
                         fill>
                </href>
            </div>
            }
            @if (component.video_id_2) {
            <href [link]="component.text_placement === 'centered_text_box' ? component.link_3 : component.link_2">
                <local-vimeo-player class="rf z-2 bg-col-w"
                                    [video-id]="component.video_id_2"
                                    [autoplay-in-viewport]="true" />
            </href>
            }
            @if (component.text_placement === 'on_image_text_box' && !client.isS) {
            <href [link]="component.link_2">
                <div class="fill z-3 flex flex-bottom flex-justify-center">
                    <div class="w-8 flex flex-column flex-justify-between"
                         [ngClass]="[component.align_2 || 'center']"
                         [style.color]="component.text_color_2"
                         [style.height.%]="56"
                         [gsap]="{ opacity: 0 }"
                         [gsapOff]="client.isCms || !component.animation"
                         [scrollTrigger]="{ id: 'opacity', start: '55% center', end: '80% center' }">
                        <div>
                            <p class="m-b-2"
                               [ngClass]="component.heading_2 ? 'o1' : ''"
                               *iCms="'heading_2' of component"></p>

                            <h1 [ngClass]="[component.title_style_2 || 'h1', component.title_2 || 'm-b-1']"
                                *iCms="'title_2' of component"></h1>

                            <a [ngClass]="component.cta_style_2 || 'p2'"
                               [routerLink]="component.link_2">
                                <span class="button__body"
                                      *iCms="'cta_text_2' of component"></span>
                            </a>
                        </div>
                        <div [ngClass]="component.caption_2 ? 'c1 p-b-3' : ''"
                             *iCms="'caption_2' of component"></div>
                    </div>
                </div>
            </href>
            }
        </div>
    </div>
    }
    @if (component.text_placement==='centered_text_box' || client.isS) {
    @if (component.link_3 && !client.isS) {
    <a class="fill"
       [routerLink]="component.link_3"></a>
    }
    <div class="fill-x fill-l fill-m z-3 flex flex-bottom w-12-s m-t-4-s pe-none-x pe-none-l pe-none-m"
         [ngClass]="component.align_box">
        <div class="w-6 w-10-s flex flex-justify-center"
             [style.height.%]="56"
             [gsap]="{ opacity: 0 }"
             [gsapOff]="client.isCms || !component.animation"
             [scrollTrigger]="{ id: 'opacity-center', start: '25% center', end: '80% center' }">
            <div class="w-8 w-12-s flex flex-column flex-justify-between"
                 [ngClass]="[component.align_3 || 'center']"
                 [style.color]="component.text_color_3">
                <div
                     [ngClass]="[component.align_3 === 'left' ? ' m-l-4-s' : '', component.align_3 === 'right' ? ' m-r-4-s' : '']">
                    <p class="m-b-2"
                       [ngClass]="component.heading_3 ? 'o1 m-t-1-s' : ''"
                       *iCms="'heading_3' of component"></p>

                    <h1 [ngClass]="[component.title_style_3 || 'h1', component.title_3 ? 'm-b-1 p-t-1-s m-b-2-s' : '']"
                        *iCms="'title_3' of component"></h1>

                    @if (!component.second_cta_text) {
                    <a [ngClass]="component.cta_style_3 || 'p2'"
                       [routerLink]="component.link_3">
                        <span class="button__body"
                              *iCms="'cta_text_3' of component"></span>
                    </a>
                    }
                    @if (component.second_cta_text) {
                    <span [class.flex]="component.align_cta === 'horizontally' && component.align_3 === 'center'">
                        <div
                             [ngClass]="[component.align_cta === 'horizontally' ? 'inline-block p-r-2' : 'm-b-2', (component.align_cta === 'horizontally' && component.align_3) === 'center' ? 'w-6 right' : '']">
                            <href hrefClass="pe-auto"
                                  [ngClass]="component.cta_style_3 || 'p2'"
                                  [link]="component.text_placement==='centered_text_box' ? component.link_3 : component.link_1">
                                <span class="button__body"
                                      *iCms="'cta_text_3' of component"></span>
                            </href>
                        </div>
                        <div
                             [ngClass]="[component.align_cta === 'horizontally' ? 'inline-block p-l-2' : '', (component.align_cta === 'horizontally' && component.align_3) === 'center' ? 'w-6 left' : '']">
                            <href hrefClass="pe-auto"
                                  [ngClass]="component.second_cta_style || 'p2'"
                                  [link]="component.text_placement==='centered_text_box' ? component.second_cta_link : component.link_2">
                                <span class="button__body"
                                      *iCms="'second_cta_text' of component"></span>
                            </href>
                        </div>
                    </span>
                    }
                </div>
                <div [ngClass]="component.caption_3 ? 'c1 p-b-3' : ''"
                     *iCms="'caption_3' of component; skipEmpty: true"></div>
            </div>
        </div>
    </div>
    }
</div>